// Quiz scoring — ported verbatim from docs/quiz/FIF Quiz v5.4.html
// (functions scoreS1 / scoreS2). Weights are intentionally unchanged.

import { DESTINATIONS, IMAGES } from '../../data/exploreCommunities';

const TOWNS = Object.keys(DESTINATIONS);

// Step 1 image picker → top-3 town matches (or the "surprise" full-day path).
// `selected` is a Set of image ids. Returns { topMatches, needsParking }.
export function scoreS1(selected) {
  const sc = {};
  TOWNS.forEach((d) => {
    sc[d] = 0;
  });
  let surprise = false;
  let needsParking = false;
  IMAGES.forEach((img) => {
    if (!selected.has(img.id)) return;
    img.tags.forEach((t) => {
      if (t === '__surprise__') surprise = true;
      else if (t === '__parking__') needsParking = true;
      else if (sc[t] !== undefined) sc[t]++;
    });
  });
  if (surprise && selected.has('sightseeing') && selected.has('nature')) {
    return { topMatches: ['__surprise__'], needsParking };
  }
  const s = Object.entries(sc)
    .sort((a, b) => b[1] - a[1])
    .filter((e) => e[1] > 0)
    .slice(0, 3)
    .map((e) => e[0]);
  return {
    topMatches: s.length > 0 ? s : ['Ocean Beach', 'Fair Harbor', 'Kismet'],
    needsParking,
  };
}

// Step 2 group + tiebreakers → winner + runners-up (within 70% of top score).
// Returns { winners, needsParking }.
export function scoreS2({ group, answers, needsParking }) {
  if (answers['1'] === 'surprise') {
    return { winners: ['__surprise__'], needsParking };
  }
  const sc = {};
  TOWNS.forEach((d) => {
    sc[d] = 0;
  });

  // GROUP TYPE
  const grp = group;
  if (grp === 'kids') {
    sc['Kismet'] += 4;
    sc['Ocean Beach'] += 3;
    sc['Fair Harbor'] += 3;
    sc['Atlantique'] += 4;
    sc['Saltaire'] += 2;
    sc['Seaview'] += 2;
  } else if (grp === 'teens') {
    sc['Kismet'] += 4;
    sc['Ocean Beach'] += 2;
    sc['Fair Harbor'] += 3;
    sc['Atlantique'] += 4;
    sc['Ocean Bay Park'] += 3;
  } else if (grp === 'mixed') {
    sc['Kismet'] += 3;
    sc['Ocean Beach'] += 2;
    sc['Fair Harbor'] += 2;
    sc['Atlantique'] += 4;
    sc['Saltaire'] += 2;
    sc['Seaview'] += 1;
  } else if (grp === 'solo') {
    sc['Kismet'] += 4;
    sc['Ocean Beach'] += 3;
    sc['Atlantique'] += 4;
    sc['Seaview'] += 1;
    sc['Ocean Bay Park'] += 3;
  }
  // adults: no group boost — let vibe + food drive it

  // VIBE
  const vibe = answers['1'];
  if (vibe === 'lively') {
    sc['Ocean Beach'] += 4;
  } else if (vibe === 'quiet') {
    sc['Atlantique'] += 3;
    sc['Saltaire'] += 4;
    sc['Seaview'] += 5;
  } else if (vibe === 'mix') {
    sc['Kismet'] += 3;
    sc['Fair Harbor'] += 2;
    sc['Atlantique'] += 3;
    sc['Ocean Bay Park'] += 3;
  }

  // FOOD
  const food = answers['2'];
  if (food === 'essential') {
    sc['Kismet'] += 3;
    sc['Ocean Beach'] += 4;
    sc['Atlantique'] += 2;
    sc['Ocean Bay Park'] += 3;
  } else if (food === 'nice') {
    sc['Kismet'] += 3;
    sc['Fair Harbor'] += 3;
    sc['Atlantique'] += 3;
    sc['Ocean Bay Park'] += 3;
  } else if (food === 'byo') {
    sc['Kismet'] += 4;
    sc['Fair Harbor'] += 3;
    sc['Atlantique'] += 5;
    sc['Ocean Bay Park'] += 3;
  } else if (food === 'unsure') {
    sc['Kismet'] += 2;
    sc['Ocean Beach'] += 3;
    sc['Fair Harbor'] += 1;
    sc['Atlantique'] += 2;
    sc['Ocean Bay Park'] += 3;
  }

  let np = needsParking;
  if (answers['3'] === 'car') np = true;

  const sorted = Object.entries(sc)
    .sort((a, b) => b[1] - a[1])
    .filter((e) => e[1] > 0);
  if (!sorted.length) return { winners: ['Ocean Beach'], needsParking: np };
  const topScore = sorted[0][1];
  const threshold = topScore * 0.7;
  const winners = sorted
    .filter((e) => e[1] >= threshold)
    .map((e) => e[0])
    .slice(0, 3);
  return { winners, needsParking: np };
}
